import React, { useEffect } from 'react';

import { Box, Card } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import afterSalesMonitoring from '../afterSalesMonitoring';
import afterSalesSettings from '../afterSalesSettings';
import * as afterSalesSettingsSelectors from '../afterSalesSettings/selectors';

import Settings from './components/Settings';

const Container = ({
    afterSalesSettingsDataId,
    fetchAfterSalesSettings,
    selectedProjectId,
}) => {
    useEffect(() => {
        fetchAfterSalesSettings(selectedProjectId);
    }, [selectedProjectId]);

    if (!afterSalesSettingsDataId)
        return (
            <afterSalesSettings.Container
                canModify={true}
                canModifyAdvancedFeatures={true}
                canViewAdvancedFeatures={true}
                selectedProjectId={selectedProjectId}
            />
        );

    return (
        <Card>
            <Card.Body>
                <Settings
                    canDelete={true}
                    canModify={true}
                    canModifyAdvancedFeatures={true}
                    canViewAdvancedFeatures={true}
                    selectedProjectId={selectedProjectId}
                />

                <Box mt={2}>
                    <afterSalesMonitoring.Container
                        canModifyAdvancedFeatures={true}
                        canViewAdvancedFeatures={true}
                        selectedProjectId={selectedProjectId}
                    />
                </Box>
            </Card.Body>
        </Card>
    );
};

const mapStateToProps = createStructuredSelector({
    afterSalesSettingsDataId:
        afterSalesSettingsSelectors.getAfterSalesSettingsDataId,
});

const mapDispatchToProps = (dispatch) => ({
    fetchAfterSalesSettings: (projectId) =>
        dispatch(afterSalesSettings.actions.fetchAfterSalesSettings(projectId)),
});

Container.propTypes = {
    afterSalesSettingsDataId: PropTypes.string,
    fetchAfterSalesSettings: PropTypes.func,
    selectedProjectId: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
